import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { AppService } from 'src/app/services/app.service';

@Component({
    selector: 'mess_lien_expire_dialog',
    templateUrl: 'mess_lien_expire_dialog.component.html',
})
export class MessLienExpire implements OnInit {

    envoi = null;
    messageRetour: string = '';
    mailSent: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<MessLienExpire>,
        @Inject(MAT_DIALOG_DATA) public data: { login: string },
        private appService: AppService,
    ) {}

    ngOnInit() {}

    dismissDialog() {
        this.dialogRef.close();
    }

    renvoyerLien() {
        this.envoi = 'loading';
        this.appService.forgetpass(this.data.login).subscribe((response) => {
            if (response && response.success) {
                this.envoi = 'done';
                this.mailSent = true;
                this.messageRetour = response.message;
            } else if (response && response.message) {
                this.envoi = 'error';
                this.messageRetour = response.message;
            } else {
                this.envoi = 'error';
                this.messageRetour = 'Une erreur est survenue. Veuillez réessayer.';
            }
        });
    }
}
